import type { FC } from "react";
import { EmptyStateCard } from "@/components/podkit/EmptyStateCard";
import { IconPlus } from "@/assets/icons/geist/IconPlus";
import { Button } from "@/components/flexkit/Button";
import { Link } from "react-router-dom";
import { editableStepsAtom, createStepIfEmptyAtomEffect, isEditingStepsAtom, stepListContainerAtom } from "./state";
import { useAtom, useAtomValue, useSetAtom } from "jotai";
import AutomationStepEditArea from "@/routes/automations/automation-details-page/AutomationStepEditArea";
import { AutomationStepList } from "@/routes/automations/automation-details-page/AutomationStepList";
import { AutomationEmptyStepCreator } from "@/routes/automations/automation-details-page/AutomationEmptyStepCreator";

export const AutomationDefinitionSection: FC = () => {
    const isEditingSteps = useAtomValue(isEditingStepsAtom);
    const editableSteps = useAtomValue(editableStepsAtom);
    const setStepListContainer = useSetAtom(stepListContainerAtom);

    useAtom(createStepIfEmptyAtomEffect);

    if (!editableSteps || (!isEditingSteps && editableSteps.length === 0)) {
        return (
            <EmptyStateCard
                title="Define your automation"
                description="Begin by describing what should happen when this automation is run."
                data-testid="workflow-executions-empty-state"
            >
                <Button asChild variant="primary" LeadingIcon={IconPlus} data-tracking-id="run-workflow-empty-state">
                    <Link to="./edit">Add Step</Link>
                </Button>
            </EmptyStateCard>
        );
    }

    return (
        <div className="flex flex-1 flex-col pb-6">
            <div
                ref={setStepListContainer}
                data-automation-edit-container
                className="relative flex h-full flex-1 flex-row items-start justify-center rounded-lg border border-border-subtle bg-[image:radial-gradient(circle,rgb(var(--border-subtle)/var(--border-subtle-opacity))_1.5px,transparent_1.5px)] bg-[length:15px_15px] px-6 py-6"
            >
                {isEditingSteps && editableSteps.length === 0 ? (
                    <AutomationEmptyStepCreator />
                ) : (
                    <div className="flex w-full max-w-screen-xl flex-row items-start justify-center gap-4">
                        <AutomationStepList steps={editableSteps} />
                        <AutomationStepEditArea />
                    </div>
                )}
            </div>
        </div>
    );
};
